import Vue from "vue";
import vcolorpicker from 'vcolorpicker'
import App from "./App.vue";
import router from "./router";
import "./style/reset.css";
import "./style/global.css";

Vue.config.productionTip = false;
Vue.use(vcolorpicker)
Vue.prototype.htmlCanvasAdjustWidth=20;
Vue.prototype.htmlCanvasAdjustX=15;


new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
